module.exports = __webpack_public_path__ + "img/file_red.e64789a1.svg";